// 特批客户申请
<template>
  <div class="woStyle">
    <!-- <div class="backBtn">
            <el-button size=mini @click="backWorkOrder()" v-if="isNewAdd == 1">返回</el-button>
      </div> -->

    <el-form
      :model="ruleForm"
      :rules="rulesTP"
      ref="ruleForm"
      label-width="110px"
      class="demo-ruleForm"
      label-position="right"
    >
      <h2 v-if="isNewAdd == '1'">提前对接客户申请</h2>
      <!-- 品牌信息 模块一 -->
      <h3>品牌信息</h3>
      <div>
        <el-form-item label="公司名称" prop="corporate_name" class="formItems">
          <el-input v-model="ruleForm.corporate_name"></el-input>
        </el-form-item>
        <el-form-item label="旗舰店名称" prop="shop_name" class="formItems">
          <el-input v-model="ruleForm.shop_name"></el-input>
        </el-form-item>
        <el-form-item label="品牌名" prop="brand_name" class="formItems">
          <el-input v-model="ruleForm.brand_name"></el-input>
        </el-form-item>
        <el-form-item label="类目" prop="category" class="formItems">
          <el-select v-model="ruleForm.category" placeholder="请选择类目">
            <el-option
              v-for="(item, index) in categoryOptions"
              :key="index"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主要产品" prop="main_products" class="formItems">
          <el-input v-model="ruleForm.main_products"></el-input>
        </el-form-item>
        <el-form-item label="旗舰店网址" prop="shop_url" class="formItems">
          <el-input v-model="ruleForm.shop_url"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户姓名" prop="customer_name" class="formItems">
                <el-input v-model="ruleForm.customer_name"></el-input>
            </el-form-item> -->
        <el-form-item label="incall" prop="incall" class="formItems">
          <el-select v-model="ruleForm.incall">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </div>

      <!-- 合作款项 期限 模块二 -->
      <h3>合作款项及期限</h3>
      <div>
        <el-form-item label="合作性质" prop="properties" class="formItems">
          <el-select
            v-model="ruleForm.properties"
            placeholder="请选择合作性质"
            disabled
          >
            <!-- :disabled="isNewAdd == '3'" -->
            <!-- 不禁用选项，仅留一个 2023.2.20 -->
            <!-- 新增提前对接续签，续签时，默认选择续签 2024.4.23 -->
            <el-option label="新签" value="1"></el-option>
            <el-option label="续签" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款方式" prop="payment_method" class="formItems">
          <!-- <el-input v-model="ruleForm.payment_method"></el-input> -->
          <el-select
            v-model="ruleForm.payment_method"
            placeholder="请选择付款方式"
          >
            <el-option label="全款" value="1"></el-option>
            <el-option label="分期" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同金额" prop="contract_amount" class="formItems">
          <el-input v-model.number="ruleForm.contract_amount"></el-input>
        </el-form-item>
        <el-form-item
          label="实际服务金额"
          prop="cooperation_amount"
          class="formItems"
        >
          <el-input v-model.number="ruleForm.cooperation_amount"></el-input>
        </el-form-item>
        <el-form-item label="首付金额" prop="down_payment" class="formItems">
          <el-input v-model.number="ruleForm.down_payment"></el-input>
        </el-form-item>
        <el-form-item
          label="尾款金额"
          prop="balance_amount"
          class="formItems"
          v-if="isShowWK"
        >
          <el-input v-model.number="ruleForm.balance_amount"></el-input>
        </el-form-item>
        <el-form-item
          label="尾款时间"
          prop="balance_time"
          class="formItems"
          v-if="isShowWK"
        >
          <!-- <el-input v-model="ruleForm.balance_time"></el-input> -->
          <div class="block">
            <el-date-picker
              v-model="ruleForm.balance_time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item
          label="尾款进度"
          prop="balance_schedule"
          class="formItems"
          v-if="isShowWK"
        >
          <el-input v-model="ruleForm.balance_schedule"></el-input>
        </el-form-item>
        <el-form-item label="打款时间" prop="payment_time" class="formItems">
          <div class="block">
            <el-date-picker
              v-model="ruleForm.payment_time"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item
          label="合同文件"
          prop="contract_documents"
          class="formItems"
        >
          <el-upload
            class="upload-demo"
            :action="$store.state.uploadUrl"
            :on-remove="handleRemove"
            :before-upload="beforeUploadContract"
            :on-success="sucUpload"
            :file-list="contractList"
          >
            <el-button size="small" type="primary" plain>点击上传</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              v-if="contractList.length == 0"
            >
              请上传JPG/PNG/PDF文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="底单文件" prop="back_file" class="formItems">
          <el-upload
            class="upload-demo"
            :action="$store.state.uploadUrl"
            :on-remove="handleRemoveBott"
            :before-upload="beforeUploadContract"
            :on-success="sucUploadBott"
            :file-list="backFileList"
          >
            <el-button size="small" type="primary" plain>点击上传</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              v-if="backFileList.length == 0"
            >
              请上传JPG/PNG/PDF文件
            </div>
          </el-upload>
        </el-form-item>
      </div>

      <!-- 合作时间 模块三 -->
      <h3>合作时间</h3>
      <div>
        <el-form-item
          label="合作时间"
          prop="cooperation_time"
          class="formItems"
        >
          <div class="block">
            <el-date-picker
              v-model="ruleForm.cooperation_time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="expireDay"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="到期时间" prop="due_time" class="formItems">
          <div class="block">
            <el-date-picker
              v-model="ruleForm.due_time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="expireDay"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="赠送服务期" prop="free_service" class="formItems">
          <el-input
            v-model.number="ruleForm.free_service"
            @change="expireDay"
          ></el-input>
        </el-form-item>
        <el-form-item label="到期天数" prop="due_day" class="formItems">
          <el-input v-model="ruleForm.due_day" disabled></el-input>
        </el-form-item>
        <el-form-item label="合作次数" prop="cooperation_num" class="formItems">
          <el-input v-model="ruleForm.cooperation_num"></el-input>
        </el-form-item>
      </div>

      <!-- 品牌资质 模块四 -->
      <h3>品牌资质</h3>
      <div>
        <el-form-item label="平台" prop="plt" class="formItems">
          <el-input v-model="ruleForm.plt"></el-input>
        </el-form-item>
        <el-form-item
          label="操作频次"
          prop="operation_frequency"
          class="formItems"
        >
          <!-- <el-input v-model="ruleForm.operation_frequency"></el-input> -->
          <el-autocomplete
            v-model="ruleForm.operation_frequency"
            :fetch-suggestions="autoInput"
            placeholder="请输入操作频次"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="SKU数" prop="sku_num" class="formItems">
          <el-input v-model="ruleForm.sku_num"></el-input>
        </el-form-item>
        <el-form-item
          label="合同购买数量"
          prop="contract_num"
          class="formItems"
        >
          <el-input v-model.number="ruleForm.contract_num"></el-input>
        </el-form-item>
        <el-form-item
          label="报表频次"
          prop="report_frequency"
          class="formItems"
        >
          <el-input v-model="ruleForm.report_frequency"></el-input>
        </el-form-item>
        <el-form-item label="报表格式" prop="report_gs" class="formItems">
          <el-select v-model="ruleForm.report_gs" placeholder="选择报表格式">
            <el-option label="EXCEL" value="EXCEL"></el-option>
            <el-option label="PPT" value="PPT"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="控价/未授权"
          prop="control_unauthorized"
          class="formItems"
        >
          <el-select
            v-model="ruleForm.control_unauthorized"
            multiple
            placeholder="请选择状态"
          >
            <el-option label="控价" value="1"></el-option>
            <el-option label="未授权" value="2"></el-option>
            <!-- <el-option label="打击" value="3"></el-option>
                    <el-option label="低价" value="4"></el-option> -->
            <el-option label="自主" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="ruleForm.remarks"></el-input>
        </el-form-item>
      </div>

      <!-- 提交人信息 模块五 -->
      <h3>对接人信息</h3>
      <div class="opp-person-info">
        <div class="tag">
          <i class="iconfont iconxiaoxi1"></i>
          <span> 如未取得对接人信息，请填“无”</span>
        </div>
        <el-form-item label="对接人" prop="contacts" class="formItems">
          <el-input v-model="ruleForm.contacts"></el-input>
        </el-form-item>
        <el-form-item label="对接人职务" prop="contacts_post" class="formItems">
          <el-input v-model="ruleForm.contacts_post"></el-input>
        </el-form-item>
        <el-form-item
          label="对接人电话"
          prop="contacts_phone"
          class="formItems"
        >
          <el-input v-model="ruleForm.contacts_phone"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="person" class="formItems">
          <el-input v-model="ruleForm.person"></el-input>
        </el-form-item>
        <el-form-item label="负责人职务" prop="person_post" class="formItems">
          <el-input v-model="ruleForm.person_post"></el-input>
        </el-form-item>
        <el-form-item label="负责人电话" prop="person_phone" class="formItems">
          <el-input v-model="ruleForm.person_phone"></el-input>
        </el-form-item>
      </div>

      <!-- 按钮区域 -->
      <el-form-item>
        <el-button
          type="primary"
          @click="directEntry('ruleForm')"
          :loading="btnState"
          >提交</el-button
        >

        <el-button @click="resetForm('ruleForm')" :loading="btnState"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from "../../libs/utils.js";
import api from "../../api";
export default {
  name: "TPCustomerApply",
  props: {
    isNewAdd: {
      // 是否是新建 1-新建 2-重新提交 3-提前对接续签 5-修改信息
      type: String,
      default: () => "1",
    },
    fatherGiveYou: {
      type: Object,
    },
    // 客户档案 --> 提交工单 --> 签约进入，绑定客户id
    autoInputByOrder: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    let testPhone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!utils.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    let dueDay = (rule, value, callBack) => {
      if (value <= 0) {
        callBack(new Error("合作日期输入有误，到期天数不应为负数或0"));
      } else {
        callBack();
      }
    };
    let test_of = utils.testOperationF;

    return {
      btnState: false,
      userId: "",
      //表单内容
      ruleForm: {
        // 品牌信息
        corporate_name: "",
        shop_name: "",
        brand_name: "",
        category: "", //类目
        main_products: "", //主要产品
        shop_url: "", //旗舰店网址
        // customer_name:'',//客户姓名
        incall: "", // 是否客户主动上门
        // 合作款项&期限
        properties: "1", //合作性质
        payment_method: "", //付款方式
        contract_amount: 0, //合同金额
        down_payment: 0, //首付
        cooperation_amount: 0, // 实际服务金额
        balance_amount: 0, //尾款金额
        balance_time: "", //尾款时间
        balance_schedule: "", //尾款进度
        payment_time: "", // 打款时间
        contract_documents: "", //合同文件
        back_file: "", //底单
        // 合作时间
        cooperation_time: "", //合作时间
        due_time: "", //到期时间
        free_service: "", //赠送服务期
        due_day: "", //到期天数
        cooperation_num: "", //合作次数
        // 品牌资质
        plt: "", //平台
        operation_frequency: "", //操作频次
        sku_num: 0, //sku数
        contract_num: "", //合同购买数量
        report_frequency: "", //报表频次
        report_gs: "", // 报表格式
        control_unauthorized: "", //控价
        remarks: "", //备注
        // 提交人信息
        contacts: "", // 联系人
        contacts_post: "", // 职务
        contacts_phone: "", // 联系人电话
        person: "", // 负责人
        person_phone: "", // 负责人电话
        person_post: "", // 负责人职务
      },
      // 表单验证规则
      rules: {
        corporate_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        shop_name: [
          { required: true, message: "请输入旗舰店名称", trigger: "blur" },
        ],
        brand_name: [
          { required: true, message: "请输入品牌名", trigger: "blur" },
        ],
        category: [{ required: true, message: "请选择类目", trigger: "blur" }],
        main_products: [
          { required: true, message: "请输入主要产品名称", trigger: "blur" },
        ],
        shop_url: [
          { required: true, message: "请输入旗舰店网址", trigger: "blur" },
        ],
        // customer_name:[
        //     { required: true, message: '请输入客户姓名', trigger: 'blur' }
        // ],
        incall: [{ required: true, message: "未选择", trigger: "change" }],
        // 合作款项&期限
        properties: [
          { required: true, message: "请选择合作性质", trigger: "change" },
        ],
        payment_method: [
          { required: true, message: "请选择付款方式", trigger: "change" },
        ],
        contract_amount: [
          { required: true, message: "请输入合同金额", trigger: "blur" },
          { type: "number", message: "请输入数字" },
        ],
        down_payment: [
          { required: true, message: "请输入首付金额", trigger: "blur" },
          { type: "number", message: "请输入数字" },
        ],
        cooperation_amount: [
          { required: true, message: "请输入实际服务金额", trigger: "blur" },
          { type: "number", message: "请输入数字" },
        ],
        balance_amount: [
          { required: true, message: "请输入尾款金额", trigger: "blur" },
          { type: "number", message: "请输入数字" },
        ],
        balance_time: [
          { required: true, message: "请选择尾款时间", trigger: "blur" },
        ],
        balance_schedule: [
          { required: true, message: "请输入尾款进度", trigger: "blur" },
        ],
        payment_time: [
          { required: true, message: "请选择打款时间", trigger: "blur" },
        ],
        contract_documents: [{ message: "请上传合同文件", trigger: "change" }],
        back_file: [
          { required: true, message: "请上传底单", trigger: "change" },
        ],

        // 合作时间
        cooperation_time: [
          { required: true, message: "请选择合作时间", trigger: "blur" },
        ],
        due_time: [
          { required: true, message: "请选择到期时间", trigger: "blur" },
        ],
        free_service: [
          { required: true, message: "请输入赠送服务期", trigger: "blur" },
          { type: "number", message: "请输入数字" },
        ],
        due_day: [
          { required: true, message: "请输入到期天数", trigger: "blur" },
          { validator: dueDay },
        ],
        cooperation_num: [
          { required: true, message: "请输入合作次数", trigger: "blur" },
        ],

        // 品牌资质
        plt: [{ required: true, message: "请输入平台", trigger: "blur" }],
        operation_frequency: [
          // { required: true, message: '请输入操作频次',}
          { validator: test_of, trigger: "change" },
        ],
        sku_num: [{ required: true, message: "请输入sku数", trigger: "blur" }],
        contract_num: [
          { required: true, message: "请输入合同购买数量", trigger: "blur" },
          { type: "number", message: "请输入数字" },
        ],
        report_frequency: [
          { required: true, message: "请输入报表频次", trigger: "blur" },
        ],
        report_gs: [{ message: "请选择报表格式", trigger: "change" }],
        control_unauthorized: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        remarks: [{ required: false, message: "请输入备注", trigger: "blur" }],

        // 提交人信息
        contacts: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contacts_post: [
          { required: true, message: "请输入职务", trigger: "blur" },
        ],
        contacts_phone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          { validator: testPhone },
        ],
      },

      // 特批申请表单验证
      rulesTP: {
        // incall: [
        //     { required: true, message: '未选择', trigger: 'change' }
        // ],
        corporate_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        // 提交人信息
        contacts: [
          { required: true, message: "请输入对接人姓名", trigger: "blur" },
        ],
        contacts_post: [
          { required: true, message: "请输入对接人职务", trigger: "blur" },
        ],
        contacts_phone: [
          { required: true, message: "请输入对接人电话", trigger: "blur" },
          // {validator:testPhone} 没有对接人电话时，需要填无，故解除校验
        ],
        person: [
          { required: true, message: "请输入负责人姓名", trigger: "blur" },
        ],
        person_post: [
          { required: true, message: "请输入负责人职务", trigger: "blur" },
        ],
        person_phone: [
          { required: true, message: "请输入负责人人电话", trigger: "blur" },
          // {validator:testPhone}
        ],
        payment_time: [
          { required: true, message: "请选择打款时间", trigger: "blur" },
        ],
        cooperation_time: [
          { required: true, message: "请选择合作时间", trigger: "blur" },
        ],
        due_time: [
          { required: true, message: "请选择到期时间", trigger: "blur" },
        ],
        due_day: [{ validator: dueDay, trigger: "change" }],
      },
      disableCache: false, // 是否禁用表单信息缓存
      //合同文件上传
      contractList: [], //已上传合同
      // showBtnCon:true,//显示上传提示，默认true
      // 底单文件上传
      showBtnBott: true, //显示上传提示
      backFileList: [], //已上传底单
      // 权限
      jurisdiction: "",
      // 是否展示尾款选项----默认展示
      isShowWK: true,
      // 操作频次选项
      autoRFOption: this.$store.state.commonOptions.operationFreqOption,
    };
  },
  watch: {
    "ruleForm.payment_method": function (newVal) {
      // 1 全款    2 分期
      newVal == "2" ? (this.isShowWK = true) : (this.isShowWK = false);
      if (newVal == "1") {
        // 清空尾款信息
        this.ruleForm.balance_amount = 0;
        this.ruleForm.balance_time = "";
        this.ruleForm.balance_schedule = "";
      }
    },
    ruleForm: {
      handler: function (val, oldval) {
        if (this.isNewAdd == "1" && !this.disableCache) {
          //   utils.sessionSetStore("TPFormData", val);
        }
        this.disableCache = false;
      },
      deep: true,
    },
    fatherGiveYou: {
      handler: function () {
        this.infoProcessFunc();
      },
      deep: true,
    },
  },
  computed: {
    categoryOptions() {
      return this.$store.getters.categoryOptions;
    },
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");

    this.jurisdiction = utils.sessionGetStore("jurisdiction");

    this.infoProcessFunc();
  },
  methods: {
    // 表单信息处理
    infoProcessFunc() {
      // 初始化
      let formData = {};
      this.contractList = [];
      this.backFileList = [];

      if (this.isNewAdd === "1" || this.isNewAdd === "3") {
        // 工单提交进入
        // 工单内容不进行缓存了，工单提交通过弹窗进行提交 2023.9.11
        if (this.autoInputByOrder) {
          Object.keys(this.autoInputByOrder).forEach((key) => {
            formData[key] = this.autoInputByOrder[key];
          });
          // 改版：客户id改为客户档案id 20230925
          // this.ruleForm.customer_id = this.autoInputByOrder.customer_id;
          formData.customer_file_id = this.autoInputByOrder.customer_file_id;
        }
        // formData = JSON.parse(utils.sessionGetStore('TPFormData'))
      } else if (
        this.isNewAdd === "2" &&
        Object.keys(this.fatherGiveYou).length != 0
      ) {
        // 重新提交
        Object.keys(this.ruleForm).forEach((key) => {
          formData[key] = this.fatherGiveYou[key];
        });
        formData.customer_file_id = this.fatherGiveYou.customer_file_id;
      } else if (
        this.isNewAdd === "5" &&
        Object.keys(this.fatherGiveYou).length != 0
      ) {
        // 修改进入
        Object.keys(this.ruleForm).forEach((key) => {
          formData[key] = this.fatherGiveYou[key];
        });
        formData.customer_file_id = this.fatherGiveYou.customer_file_id;
      }

      if (formData && Object.keys(formData).length != 0) {
        Object.keys(this.ruleForm).forEach((key) => {
          if (
            formData[key] == null ||
            formData[key] == undefined ||
            formData[key] == "null" ||
            formData[key] == "undefined"
          ) {
            formData[key] = "";
          }
        });
        this.ruleForm = { ...formData };

        this.ruleForm.contract_num = Number(formData.contract_num); // 合同数量
        this.ruleForm.contract_amount = Number(formData.contract_amount); // 合同金额
        this.ruleForm.down_payment = Number(formData.down_payment); // 首付金额
        this.ruleForm.cooperation_amount = Number(formData.cooperation_amount); // 实际服务金额
        this.ruleForm.balance_amount = Number(formData.balance_amount); // 尾款金额
        this.ruleForm.free_service = Number(formData.free_service); // 赠送服务期
        // 新签、续签进入不用转换
        if (this.isNewAdd != "1" && this.isNewAdd != "3") {
          this.ruleForm.control_unauthorized = formData.control_unauthorized
            ? formData.control_unauthorized.split(",")
            : []; //控价/未授权
        }

        // 合同文件
        if (formData.contract_documents != "") {
          formData.contract_documents.split(",").forEach((item) => {
            if (item != "") {
              this.contractList.push({
                name: item.split("/").pop(),
                url: item,
              });
            }
          });
        }
        // 底单文件
        if (formData.back_file != "") {
          formData.back_file.split(",").forEach((item) => {
            if (item != "") {
              this.backFileList.push({
                name: item.split("/").pop(),
                url: item,
              });
            }
          });
        }
      }
    },
    // 操作频次
    autoInput(queryStr, cb) {
      var restaurants = this.autoRFOption;
      var results = queryStr
        ? restaurants.filter(this.createFilter(queryStr))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryStr) {
      return (item) => {
        // return (item.label.toLowerCase().indexOf(queryStr.toLowerCase()) === 0);
        return item.value.split(queryStr).length > 1;
      };
    },
    // 自动计算到期天数
    expireDay() {
      if (
        this.ruleForm.due_time == "" ||
        this.ruleForm.cooperation_time == ""
      ) {
        return;
      }
      // 到期天数 = 到期日期 - 当前日期
      let nowDate = this.getNowFormatDate();
      let day = this.countDate(nowDate, this.ruleForm.due_time); // (当前日期，到期日期)
      this.ruleForm.due_day = Number(day) + Number(this.ruleForm.free_service);
    },

    //计算日期差
    countDate(sDate1, sDate2) {
      //sDate1和sDate2是2006-12-18格式
      let dateSpan, tempDate, iDays;
      sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      // dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays;
    },

    // 获取当前日期---2020/11/05
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    // 返回按钮
    backWorkOrder() {
      window.history.go(0);
    },

    // 合同文件上传相关

    handleRemove(file, fileList) {
      //删除后触发
      this.ruleForm.contract_documents = "";
      fileList.forEach((item) => {
        if (item.response) {
          this.ruleForm.contract_documents += item.response.data + ",";
        } else {
          this.ruleForm.contract_documents += item.url + ",";
        }
      });
    },
    sucUpload(response) {
      //上传成功后
      this.ruleForm.contract_documents += response.data + ","; //合同文件地址
    },
    beforeUploadContract(file) {
      let isJPG = file.type === "image/jpeg",
        isPNG = file.type === "image/png",
        isPDF = file.type === "application/pdf";
      if (!isJPG && !isPNG && !isPDF) {
        this.$message.error("请上传JPG/PNG/PDF文件");
        return false;
      }
    },

    // 底单文件上传相关

    handleRemoveBott(file, fileList) {
      //删除后触发
      this.ruleForm.back_file = "";
      fileList.forEach((item) => {
        if (item.response) {
          this.ruleForm.back_file += item.response.data + ",";
        } else {
          this.ruleForm.back_file += item.url + ",";
        }
      });
    },
    sucUploadBott(response) {
      //上传成功后
      // this.showBtnBott = false;
      // console.log(response.data)
      this.ruleForm.back_file += response.data + ","; //底单文件地址
      // console.log(this.ruleForm.back_file)
    },

    // 特批客户录入
    directEntry(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 更新按钮状态
          this.btnState = true;
          //提交操作
          // 新建工单参数

          let paramObj = {};
          Object.keys(this.ruleForm).forEach((key) => {
            if (this.ruleForm[key]) {
              paramObj[key] = this.ruleForm[key];
            }
          });

          if (
            this.isNewAdd == "1" ||
            this.isNewAdd == "2" ||
            this.isNewAdd == "3"
          ) {
            // 新建 or 重新提交 or 提前对接续签
            if (this.autoInputByOrder) {
              // 自动带入客户档案中客户所属人
              paramObj.sale_id = this.autoInputByOrder.sale_id;
            } else {
              paramObj.sale_id = this.userId;
            }
            paramObj.state = "7"; //工单标识   特批客户申请
            paramObj.is_contract = 2;

            api
              .insertdirectcustomer(paramObj)
              .then((res) => {
                // 更新按钮状态
                this.btnState = false;
                // console.log(res)

                // 传给父组件
                this.$emit("completeView", "true");

                // 清除缓存的表单信息
                if (this.isNewAdd == "1" || this.isNewAdd == "3") {
                  this.resetForm("ruleForm");
                }
              })
              .catch((error) => {
                // 更新按钮状态
                this.btnState = false;
                utils.notificationInfo("提示", "提交失败", "warning");

                return Promise.reject(error);
              });
          } else {
            // 信息修改
            paramObj.id = this.fatherGiveYou.id;
            paramObj.up_user = this.userId;
            api
              .reviseCBInfo(paramObj)
              .then((res) => {
                // 按钮更新状态
                this.btnState = false;
                // console.log('返回值',res)
                utils.notificationInfo("提示", "修改信息成功", "success");
                this.$emit("completeFunc");
              })
              .catch((err) => {
                // 按钮更新状态
                this.btnState = false;
                console.log(err);
                utils.notificationInfo("提示", "修改信息失败", "error");
              });
          }
        } else {
          utils.notificationInfo("提示", "提交失败", "warning");
          return false;
        }
      });
    },

    // 重置
    resetForm(formName) {
      this.disableCache = true; // 禁用表单信息缓存
      // this.$refs[formName].resetFields();
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = "";
      });
      this.ruleForm.contract_num = 0; // 合同数量
      this.ruleForm.contract_amount = 0; // 合同金额
      this.ruleForm.down_payment = 0; // 首付金额
      this.ruleForm.cooperation_amount = 0; // 实际服务金额
      this.ruleForm.balance_amount = 0; // 尾款金额
      this.ruleForm.free_service = 0; // 赠送服务期
      this.contractList = [];
      this.backFileList = [];
      utils.sessionRemoveStore("TPFormData");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  ::v-deep .el-form-item__label {
    font-size: 12px;
  }
}

.opp-person-info {
  position: relative;

  .tag {
    position: absolute;
    top: -39px;
    left: 125px;
    color: red;
  }
  .iconxiaoxi1 {
    color: red;
  }
}

.formItems {
  ::v-deep input {
    width: 220px;
  }
}
</style>
